import { Checkbox, Stack } from '@vtex/admin-ui'
import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useCollectionsImport, useSkusImport } from 'hooks'
import { useIntl } from 'react-intl'
import { LIMITS } from 'shared'
import {
  CollectionsSelector,
  CONNECTOR,
  Rule,
  RuleContent,
  RuleStack,
  SkuSelector,
} from 'ui'
import { ProgressiveDiscountTrigger } from '../../../../../../typings'
import messages from '../messages'

type Props = {
  name: string
  form: FormState
}

export function EditorTrigger(props: Props) {
  const { name, form } = props

  const { $t } = useIntl()

  const trigger: ProgressiveDiscountTrigger = useWatch({
    form,
    name,
  })

  const { skus, collections, sameItemsOnly } = trigger

  const { importCollections, loading: importingCollections } =
    useCollectionsImport()
  const { importSkus, loading: importingSkus } = useSkusImport()

  return (
    <Stack space="$space-4">
      <RuleStack>
        <Rule>
          <RuleContent fluid>
            <SkuSelector>
              <SkuSelector.Header>
                <SkuSelector.Download values={skus} />
                <SkuSelector.Upload
                  name={`${name}.skus`}
                  form={form}
                  importer={importSkus}
                  maxEntries={LIMITS.MAX_BUY_TOGETHER_SKUS}
                />
              </SkuSelector.Header>
              <SkuSelector.Selector
                name={`${name}.skus`}
                state={form}
                loading={importingSkus}
                maxEntries={LIMITS.MAX_BUY_TOGETHER_SKUS}
              />
            </SkuSelector>
          </RuleContent>
        </Rule>

        <Rule connector={CONNECTOR.OR}>
          <RuleContent fluid>
            <CollectionsSelector>
              <CollectionsSelector.Header>
                <CollectionsSelector.Download values={collections} />
                <CollectionsSelector.Upload
                  name={`${name}.collections`}
                  form={form}
                  importer={importCollections}
                  maxEntries={LIMITS.MAX_BUY_TOGETHER_COLLECTIONS}
                />
              </CollectionsSelector.Header>

              <CollectionsSelector.Selector
                name={`${name}.collections`}
                form={form}
                loading={importingCollections}
                maxEntries={LIMITS.MAX_BUY_TOGETHER_COLLECTIONS}
              />
            </CollectionsSelector>
          </RuleContent>
        </Rule>
      </RuleStack>

      <Checkbox
        label={$t(messages.trigger.sameItemsOnly)}
        checked={sameItemsOnly}
        onChange={(event) =>
          form.setValue(`${name}.sameItemsOnly`, event.target.checked)
        }
      />
    </Stack>
  )
}
